// extracted by mini-css-extract-plugin
export default {"root":"Z00gi","thumb":"_1Iy0q","selected":"_1MiZx"};